export const joditConfig: any = {
  addNewLine: false,
  statusbar: false,
  buttons: "bold,italic,underline,strikethrough,|,ul,ol,|,link,source,eraser",
  buttonsSM: "bold,italic,underline,strikethrough,|,ul,ol,|,link,source,eraser",
  buttonsMD: "bold,italic,underline,strikethrough,|,ul,ol,|,link,source,eraser",
  buttonsXS: "bold,italic,underline,strikethrough,|,ul,ol,|,link,source,eraser",
  defaultActionOnPaste: "insert_as_html",
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  limitChars: 4000,
  spellcheck: true,
  enter: "p", // <br> creates bug when toggling lists
  editorClassName: "prose min-w-full prose-ul:leading-4 prose-ol:leading-4",
};
